const endpointsConfig = {
   // backendUrl: 'http://pruebasapi.predictAnalyzer.com/'
   /**
    * Luego tendremos que quitar esto y colocar 
    * "process.env.REACT_APP_BACK_URL"
    * en donde se use "backendUrl"
    */
   backendUrl: process.env.REACT_APP_BACK_URL
}

export default endpointsConfig